import API from "../../../utils/helpers/API.helpers";

const PeerReviewService = {
  async getPeerReview(mkSpesialId) {
    if (mkSpesialId) {
      return await API.get({
        endpoint: `/peer-review/?mk_spesial=${mkSpesialId}`,
      });
    }
    return await API.get({ endpoint: `/peer-review/` });
  },

  async postPeerReview(data) {
    return await API.post({ endpoint: "/peer-review/", data: data });
  },

  async getPeerReviewById(id) {
    return await API.get({ endpoint: `/peer-review/${id}/` });
  },

  async updatePeerReview(data) {
    return await API.put({
      endpoint: `/peer-review/${data.id}/`,
      data: data,
    });
  },
};

export default PeerReviewService;
